import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router";
import { notificationComponents } from "../../config";
import { useAppDispatch } from "../../redux/store";
import { setSelectedCategoryForDetails } from "../../redux/features/notifications/slice";
import { useEffect, useMemo } from "react";
import StandardNotificationDetail from "./StandardNotificationDetail";

const PENDING_STORAGE_KEY = "notification_detail_pending";

const DynamicNotificationDetail: React.FC = () => {
    const dispatch = useAppDispatch();
    const categoryFromRedux = useSelector((state: RootState) => state.notification.selectedCategoryForDetails);
    const pendingFromStorage = useMemo(() => {
        try {
            const raw = localStorage.getItem(PENDING_STORAGE_KEY);
            return raw ? (JSON.parse(raw) as { category?: string; transactionId?: string; employeeId?: number }) : null;
        } catch {
            return null;
        }
    }, []);
    const categoryCode = (categoryFromRedux || pendingFromStorage?.category) ?? undefined;
    const navigate = useNavigate();

    useEffect(() => {
        if (pendingFromStorage?.category && !categoryFromRedux) {
            dispatch(setSelectedCategoryForDetails(pendingFromStorage.category));
        }
    }, [pendingFromStorage?.category, categoryFromRedux, dispatch]);

    if (!categoryCode || categoryCode == undefined) {
        navigate(-1); // Navigate back if no category is selected
    }

    const Component = notificationComponents[categoryCode!];
    if (!Component) {
        return <StandardNotificationDetail />;
    }

    return <Component />;
};

export default DynamicNotificationDetail;
export { default as OpenShiftAvailableNotificationDetail } from "./OpenShiftAvailableNotificationDetail";
export { default as UnavailabilityNotificationDetail } from "./UnavailabilityNotificationDetail";
export { default as MealBreakNotificationDetail } from "./MealBreakNotificationDetail";
